import I_globals from './interfaces/I_globals'

export const globals: I_globals = {
  mediaQueries: {
    mobile: 0,
    tablet: 768,
    laptop: 992,
    desktop: 1200
  }
}
